<template>
  <vue-modal-2
    name="DemandeProductMarketplace"
    :headerOptions="{ title: typeAction === 'marketplace' ? typeActionMettre ? `Mettre en Ligne` : `Retirer une demande de produit`: 'Demande Produit' }"
    :noFooter="true"
    modalSize="lg"
    @on-close="OpenClosePopupModalHandler('close', 'DemandeProductMarketplace')"
  >
    <div class="rounded-lg shadow-sm">

      <div class="flex flex-col border border-gray-500 p-4 m-4 rounded-lg relative" v-if="currentUser.type === 'Seller'">
        
        <div class="flex w-full mb-5">
          <input id="inputshipping" @input="searchProductByIDHandler($event.target.value)" :disabled="loading"
            :placeholder="typeAction === 'marketplace' && !typeActionMettre ? 'Demande ID ...' : 'ID Produit ...'" v-model="searchText" type="search"
            autofill="off"
            class="border-t  text-gray-700 border-gray-500  text-xs border-b border-l border-r rounded-l-md rounded-r-md w-full focus:outline-none py-1 px-4">
        </div>
      </div>
      <loading :active.sync="loading" :is-full-page="fullPage"></loading> 
      <!-- Main Content Container -->
      <div v-if="data && (data.details || warehouses.length>0)" class="bg-white dark:bg-slate-800 rounded-lg overflow-hidden">
        <!-- Product Info Section -->
        <div  class="p-5">
          <!-- Product Header with Image and Info -->
          <div class="flex items-center space-x-4 mb-6">
            <div
              class="h-16 w-16 rounded-full overflow-hidden border-2 border-primary shadow-md"
            >
              <img
                :src="data.picture||data.productObject.picture"
                alt="Product"
                class="h-full w-full object-cover"
              />
            </div>
            <div>
              <h5 class="text-lg font-semibold text-slate-800 dark:text-white">
                {{ data.name||data.productObject.name }}
              </h5>
              <span class="text-sm text-slate-500 dark:text-slate-400">{{
                data.id || data.id_v2||data.productObject.id||data.productObject.id_v2
              }}</span>
            </div>
          </div>

          
          <!-- Warehouse Selection --> 
          <div v-if="typeAction !== 'marketplace' || (typeAction === 'marketplace' && typeActionMettre)" class="mb-6">
            <div class="relative">
              <div
                class="absolute -top-3 left-4 bg-white dark:bg-slate-800 px-2"
              >
                <label
                  class="text-xs font-medium text-slate-600 dark:text-slate-400"
                >
                  Warehouses <span class="text-red-500">*</span>
                </label>
              </div>
              <div
                class="border border-slate-300 dark:border-slate-600 hover:border-primary focus-within:border-primary focus-within:ring-1 focus-within:ring-primary/30 rounded-[6px] p-3 transition-all duration-300"
              >
                <v-select
                  multiple
                   :disabled="typeAction === 'marketplace' && data.oldStatus && data.oldStatus === 'approved'?true:false"
                  v-model="warehouseSelected"
                  @input="setWarehouseSelected"
                  placeholder="Select warehouses..."
                  label="name"
                  :options="warehouses"
                  class="text-slate-700 dark:text-slate-300"
                ></v-select>
              </div>
            </div>
          </div>

          <!-- Tabs Section -->
           <template v-if="typeAction !== 'marketplace' || (typeAction === 'marketplace' && typeActionMettre)">
              <div v-if="warehouseSelected.length > 0" class="mt-4">
              <tabs
                :options="{
                  defaultTabHash: `tab_${warehouseSelected[0].country}`,
                }"
                class="warehouse-tabs"
              >
                <tab
                  v-for="(pr, key) in warehouseSelected"
                  :key="key"
                  :id="'tab_' + pr.country"
                  :name="pr.name"
                >
                  <div
                    class="bg-gradient-to-r from-primary/5 to-blue-300/5 p-5 rounded-[6px]  mt-0"
                  >

                  <div v-if="typeAction === 'marketplace'"  class="w-full mb-5">
                      <div 
                            class="border  hover:border-green-500  border-gray-600  focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1"
                          >
                            <div
                              class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                            >
                              <p>
                                <label for="code" class="bg-white text-gray-700 px-1">Catégorie </label>
                              </p>
                            </div>
                            <p class="select-categoris"> 
                              <v-select v-if="data.productObject && data.productObject.category"
                                v-model="data.productObject.category"
                                placeholder="Catégorie ..."
                                :options="categories"
                              />
                              <v-select v-else
                                v-model="data.category"
                                placeholder="Catégorie ..."
                                :options="categories"
                              />
                            </p>
                          </div>
                    </div>

                    <div class="grid gap-6" :class="typeAction === 'marketplace'?'md:grid-cols-2':'md:grid-cols-1'">

                      <div v-if="typeAction === 'marketplace'"  class="border hover:border-green-500  border-gray-600  hover:border-green-500  border-gray-600  focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                        <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                          <p>
                            <label for="price" class="bg-white text-gray-700 px-1">{{ $t("Prix de vente") }} <span :class="$colors.required">*</span></label>
                          </p>
                        </div>
                        <div  class="w-full rounded-md inline-flex border">
                          <div class="flex items-center  font-bold text-s  w-100px justify-center border border-gray-300 w-1/4 bg-gray-200"><span> {{ pr.currency }}</span></div>
                          <input type="number" v-model="pr.info.price"  min="0" class="w-full focus:outline-none rounded-md bg-white  text-gray-700 focus:text-gray-600 p-2">
                        </div>
                      
                      </div>
                    
                      <div class="relative">
                        <div
                          class="absolute -top-3 left-4 bg-white dark:bg-slate-800 px-2"
                        >
                          <label
                            class="text-xs font-medium text-slate-600 dark:text-slate-400"
                          >
                            {{ $t(typeAction === 'marketplace'?"Quantity":"Quantité Demandée") }}
                            <span class="text-red-500">*</span>
                          </label>
                        </div>
                        <div
                          class="flex items-center border border-slate-300 dark:border-slate-600 hover:border-primary focus-within:border-primary focus-within:ring-1 focus-within:ring-primary/30 rounded-[6px] overflow-hidden transition-all duration-300"
                        >
                          <div
                            class="px-3 py-2 bg-slate-50 dark:bg-slate-700 border-r border-slate-200 dark:border-slate-600"
                          >
                            <Icon
                              icon="heroicons-outline:calculator"
                              class="h-5 w-5 text-primary"
                            />
                          </div>
                          <input
                            type="number"
                          
                            v-model="pr.info.quantity"
                            min="0"
                            class="w-full p-3 bg-white dark:bg-slate-800 focus:outline-none text-slate-700 dark:text-slate-300"
                            placeholder="Enter quantity"
                          />
                        </div>
                      </div>
                    </div>
                    
                    <div  class="w-full">
                      <div v-if="typeAction === 'marketplace'" class="bg-blue-100 border-t border-b border-blue-500 text-blue-700 px-4 py-3 mt-1" role="alert">
                        <p class="font-bold">Votre Profit: <b>Prix ​​de vente - (Service Fees (10%))</b></p>
                        <p v-if="pr.info.price" class="text-sm">Profit Total:  <b>{{ $f.getPriceMarket({price:pr.info.price,quantity:1,serviceFees:10}) }} <sup>{{ pr.currency }}</sup></b></p>
                      </div>

                      <div v-if="typeAction === 'marketplace'" id="warn2" role="alert" aria-live="polite" class="max-w-2xl mt-2 mx-auto p-4 rounded-lg border-l-4 border-orange-500 bg-orange-100 text-orange-900 shadow">
                        <div class="flex items-start gap-4">
                          <svg class="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0zM12 9v4m0 4h.01"/>
                          </svg>

                          <div class="flex-1">
                            <p class="font-semibold">Impossibilité de modification — rejeté une Demande deja approved</p>
                            <div class="mt-2 text-sm text-gray-700">
                              <p class="mb-2">Le fournisseur a rejeté ce produit de la marketplace. Important :</p>
                              <ul class="list-disc list-inside space-y-1 ml-2">
                                <li>Les stocks réservés par les vendeurs <strong>ne seront pas restitués automatiquement</strong></li>
                                <li>Les quantités restantes demeurent disponibles dans la marketplace</li>
                                <!-- <li>Les vendeurs disposent de <strong class="text-red-900">10 jours</strong> pour réapprovisionner leur stock</li>
                                <li>Sans action dans ce délai → Annulation de la réservation et libération du stock</li> -->
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>

                    
                    <div v-if="typeAction !== 'marketplace'"  class="">
                      <div id="alert-border-1" class="flex items-center p-4 mb-4 text-blue-800 border-t-4 border-blue-300 bg-blue-50 dark:text-blue-400 dark:bg-gray-800 dark:border-blue-800" role="alert">
                        <svg class="shrink-0 w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
                        </svg>
                        <div class="ml-3 text-sm font-medium">
                          Quantité disponible en stock: <b>{{ pr.info.stock }}</b>.
                        </div>
                      </div>
                      <div  role="alert" class="bg-blue-100 border-t border-b border-blue-500 text-blue-700 px-4 py-3 mt-1">
                        <p  class="font-bold">Votre Profit: <b>Prix de vente - (Shiping Fees + Prix d'Achat)</b></p>
                      </div>
                    </div>
                    
                  </div>
                </tab>
              </tabs>
              </div>
           </template>

          

        </div>
      </div>

      <!-- Footer Actions -->
      <div  class="my-4 flex items-center justify-between px-5">
        <template v-if="currentUser.type === 'Seller'">
          <button
            @click="OpenClosePopupModalHandler('close', 'DemandeProductMarketplace')"
            class="px-4 py-3 rounded-[6px] bg-slate-200 hover:bg-slate-300 text-slate-700 font-medium transition-all duration-300 flex items-center space-x-2"
          >
            <Icon icon="heroicons-outline:x" class="text-lg" />
            <span>Cancel</span>
          </button>

          <button v-if="data && (data.details || warehouses.length>0)"
            @click="EmitActionNewShippHandler('DemandeProductMarketplace', data, warehouseSelected)"
            class="px-4 py-3 rounded-[6px] bg-gradient-to-r from-primary to-blue-500 hover:from-primary/90 hover:to-blue-600 text-white font-medium transition-all duration-300 flex items-center space-x-2 relative"
            :class="loading ? 'opacity-75 cursor-not-allowed' : ''"
          >
            <loading :active.sync="loading" :is-full-page="fullPage"></loading>
            <Icon icon="heroicons-outline:paper-airplane" class="text-lg" />
            <span> {{ typeAction === 'marketplace' && !typeActionMettre ? 'Envoyer la demande de rejet' : 'Envoyer la demande'   }}</span>
          </button>
        </template>

        <template v-else>
          <button
            @click="EmitActionNewShippHandler('DemandeProductMarketplace',{...data,status:'rejected'}, warehouseSelected)"
            class="px-4 py-3 rounded-[6px] bg-red-100 hover:bg-red-200 text-red-600 font-medium transition-all duration-300 flex items-center space-x-2"
          >
            <Icon icon="heroicons-outline:x-circle" class="text-lg" />
            <span>Reject</span>
          </button>

          <button
            @click="EmitActionNewShippHandler('DemandeProductMarketplace',{...data,status:'approved'}, warehouseSelected)"
            class="px-4 py-3 rounded-[6px] bg-green-100 from-emerald-500 to-primary hover:from-emerald-600 hover:to-primary/90 text-green-600 font-medium transition-all duration-300 flex items-center space-x-2 relative"
            :class="loading ? 'opacity-75 cursor-not-allowed' : ''"
          >
            <loading :active.sync="loading" :is-full-page="fullPage"></loading>
            <Icon icon="heroicons-outline:check-circle" class="text-lg" />
            <span>Approve</span>
          </button>
        </template>
      </div>

    </div>
  </vue-modal-2>
</template>

<script>
import { string } from 'yup';
export default {
  props: {
    currentUser: { type: Object },
    idWharhouse: { type: Object },
    searchProductByID: Function,
    OpenClosePopupModal: Function,
    EmitActionNewShipp: Function,
    title: String,
    loading: Boolean,
    amount: Number,
    currency: String,
    typeAction: {
      type: String,
      default() {
        return '';
      },
    },
    typeActionMettre: {
      type: Boolean,
      default() {
        return true;
      },
    },
    type: String,
    icon: String,
    fullPage: {
      type: Boolean,
      default() {
        return false;
      },
    },
    categories: {
      type: Array,
      default() {
        return [];
      },
    },
    statusSous: {
      type: Array,
      default() {
        return [];
      },
    },
    filters: {
      type: Object,
      default() {
        return {};
      },
    },
    paginate: {
      type: Object,
      default() {
        return {};
      },
    },
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      warehouses: [],
      warehouseSelected: [],
      searchText:"",
      localCategory: null
    };
  },
  mounted() {
  // if(this.data && this.data._id) this.localCategory = this.data.category || (this.data.productObject && this.data.productObject.category) || null;
  },
  watch: {
    data: function () {
      if (this.data && (this.data.details || this.data.productObject)) {
        console.log('data--------',this.data)
        let dataW=this.data.details||(this.data.productObject.info.map(({ warehouse, price, quantity }) => ({
          ...warehouse,
          info: { price, quantity }
        })))
        console.log('dataW--------',dataW)
        this.warehouses = dataW[0].warehouse?dataW.filter((item) => item.warehouse && item.warehouse.is_primary).map((el) => ({
            ...el.warehouse,
            info: { quantity: 0,price:0 },
          })):dataW;

          if(this.data.productObject) this.warehouseSelected = dataW;

          console.log('warehouses--------',this.warehouseSelected)
          console.log('data.productObject--------',this.data.productObject)

          if(this.data.product && this.data.product.details){
            this.warehouseSelected.forEach(wraehouse => {
               const checkW=this.data.product.details.find(el=> el.warehouse.toString() === wraehouse._id.toString());
               if(checkW) wraehouse.info.stock= checkW.quantity.inStock;
            });
          }

      } else {
        this.warehouses = [];
        this.warehouseSelected = [];
      }
    },
    localCategory(value) {
       if(this.data.productObject) this.data.productObject.category = value;
       else this.data.category = value;
    }
  },
  methods: {
    OpenClosePopupModalHandler: async function (val, val2) {
       this.OpenClosePopupModal(val, val2);
    },
    EmitActionNewShippHandler: async function (val, val2, val3 = []) {
      let checkActiopnIsRejected = this.typeAction === 'marketplace' && !this.typeActionMettre ? true : false;
      this.EmitActionNewShipp(val, val2, val3,checkActiopnIsRejected);
    },
    async searchProductByIDHandler(val) {
        let checkActiopnIsRejected = this.typeAction === 'marketplace' && !this.typeActionMettre ? true : false;
        this.searchProductByID(val, this.searchText, checkActiopnIsRejected);
    },
    getGain(data,ServiceFees=10) {
      //const ServiceFees = 10; // percent
      const discount = data.price * (ServiceFees / 100);
       return parseInt(data.price - discount);
    },
    setWarehouseSelected(warehousesData){
       console.log('warehousesData---------',warehousesData)
    }
  },
};
</script>

<style scoped>
.warehouse-tabs .tabs-header {
  display: flex;
  gap: 0.5rem;
  overflow-x: auto;
  padding-bottom: 0.5rem;
}

.warehouse-tabs .tabs-header li {
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  border-radius: 0.5rem;
  background-color: #f1f5f9;
  color: #475569;
  font-weight: 500;
  transition: all 0.3s;
}

@media (prefers-color-scheme: dark) {
  .warehouse-tabs .tabs-header li {
    background-color: #334155;
    color: #cbd5e1;
  }
}

.warehouse-tabs .tabs-header li.active {
  background-color: var(#19a69d);
  color: white;
}

.noselect {
  user-select: none;
  pointer-events: none;
}
</style>
